import { render, staticRenderFns } from "./SanctionsData.vue?vue&type=template&id=06ddb010"
import script from "./SanctionsData.vue?vue&type=script&lang=js"
export * from "./SanctionsData.vue?vue&type=script&lang=js"
import style0 from "./SanctionsData.vue?vue&type=style&index=0&id=06ddb010&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports